import * as yup from "yup";

export const mortgageCalcSchema = yup.object().shape({
  propertyValue: yup
    .number()
    .required("Property value is required")
    .nullable()
    .typeError("Property value is required"),
  propertyPrice: yup
    .number()
    .required("Property price is required")
    .nullable()
    .typeError("Property value is required"),
  //   equityContribution: yup.string().required("Equity Contribution required"),
  dob: yup.string().required("Date of birth is required"),
  netSalary: yup
    .number()
    .required("Net salary is required")
    .nullable()
    .typeError("Property value is required"),
  interestRate: yup
    .number()
    .required("Interest rate is required")
    .nullable()
    .typeError("Property value is required"),
  tenor: yup
    .number()
    .required("Tenor is required")
    .nullable()
    .typeError("Property value is required"),
});

export const prequalFailureSchema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .required("Email is required")
    .email("Enter a valied email"),
  phone: yup.string().required("Phone number is required"),
});